import React from "react";
import { Button, Card, Chip, Stack, Typography } from "@mui/material";

export default function ConversationContextStrip({
  activeSprint,
  context,
  onOpenSprint,
  onStartSprint,
  startingSprint = false,
}) {
  const hasActiveSprint = Boolean(activeSprint?.id);

  return (
    <Card
      variant="outlined"
      sx={{
        p: 1.6,
        borderRadius: "8px",
        borderColor: "rgba(220, 230, 240, 0.96)",
        backgroundColor: "#f8fbff",
      }}
    >
      <Stack direction="row" spacing={1.2} alignItems="center" justifyContent="space-between">
        <Stack spacing={0.55}>
          <Chip
            label={hasActiveSprint ? "Active Accountability" : "Connected"}
            size="small"
            sx={{
              width: "fit-content",
              borderRadius: "8px",
              backgroundColor: "#eef4fb",
              color: "#17345d",
              fontWeight: 800,
            }}
          />
          <Typography sx={{ fontWeight: 800, color: "#14213d" }}>
            {context?.focusTitle || activeSprint?.focusTitle || "Your TrustBud connection"}
          </Typography>
          {context?.focusSubtitle ? (
            <Typography variant="body2" sx={{ color: "#718198" }}>
              {context.focusSubtitle}
            </Typography>
          ) : null}
        </Stack>

        {hasActiveSprint ? (
          <Button variant="outlined" onClick={onOpenSprint} sx={{ borderRadius: "8px", textTransform: "none" }}>
            Open Accountability
          </Button>
        ) : context?.canStartSprint ? (
          <Button
            variant="outlined"
            onClick={onStartSprint}
            disabled={startingSprint}
            sx={{ borderRadius: "8px", textTransform: "none" }}
          >
            {startingSprint ? "Starting..." : "Start Accountability"}
          </Button>
        ) : null}
      </Stack>
    </Card>
  );
}
